import {
    formatDate,
} from "../utils/util";

export default {
    methods: {
        replaceMeetingDataPlaceholders(meetingObject, meetingPurpose) {
            const placeHolderVariables = {
                "{{%meeting_name%}}": meetingObject.meetingName,
                "{{%date%}}": formatDate(
                    new Date(meetingObject.scheduletStartTimeInUTC),
                    this.dateFormat
                ),
                "{{%tenant%}}": this.tenantName,
                "{{%meeting_description%}}": meetingObject.description,
                "{{%start_date%}}": formatDate(
                    new Date(meetingObject.scheduletStartTimeInUTC),
                    this.displayDateFormat
                ),
                "{{%end_date%}}": formatDate(
                    new Date(meetingObject.scheduledEndTimeInUTC),
                    this.displayDateFormat
                ),
                "{{%location%}}": meetingObject.location,
                "{{%topic_details%}}": meetingPurpose,
                "{{%conference_link%}}": meetingObject.meeting_link,
                "{{%meeting_type%}}": this.isMeetingDeleted ? this.getMeetingType(meetingObject) : meetingObject.meetingType,
                "{{%resolution_type%}}": meetingObject.resolutionType,
                "{{%meeting_remaining_days%}}": daysInExpire.call(this, meetingObject.scheduletStartTimeInUTC)
            };
            return placeHolderVariables
        },
    }
}

function daysInExpire(scheduledStartTimeInUTC) {
    const diffInMs = new Date(scheduledStartTimeInUTC) - new Date();
    const remainingDays = Math.round(diffInMs / (1000 * 60 * 60 * 24));

    if (remainingDays < 0) {
        return this.$t("template.lblInPast");
    }
    if (remainingDays === 0) {
        return "Today";
    }
    return remainingDays;
}